"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intervalToMs = intervalToMs;
var _loggingAndErrors = require("@avantia/logging-and-errors");
const oneSecondMs = 1000;
const oneMinuteMs = 60 * oneSecondMs;
const oneHourMs = 60 * oneMinuteMs;
const oneDayMs = 24 * oneHourMs;
function intervalToMs(interval, options) {
  // eslint-disable-next-line prefer-const
  let {
    min,
    max,
    unbounded
  } = options || {};
  if (unbounded === true) {
    if (min !== undefined || max !== undefined) {
      throw new _loggingAndErrors.HpError(`When 'unbounded' is true, 'max' and 'min' cannot be specified`);
    }
    min = Number.MIN_SAFE_INTEGER;
    max = Number.MAX_SAFE_INTEGER;
  } else {
    if (min === undefined) {
      min = 1;
    }
    if (max === undefined) {
      max = 8 * oneHourMs;
    }
  }
  const match = /^(-?\d{1,8})(d|h|m|s)?$/.exec(`${interval}`);
  if (match) {
    const num = parseInt(match[1], 10);
    const suffix = match[2] || '';
    let res;
    if (suffix === '') {
      res = num;
    } else {
      switch (suffix) {
        case 'm':
          res = num * oneMinuteMs;
          break;
        case 's':
          res = num * oneSecondMs;
          break;
        case 'h':
          res = num * oneHourMs;
          break;
        case 'd':
          res = num * oneDayMs;
          break;
      }
    }
    if (res !== undefined) {
      const range = {
        unbounded: true
      };
      if (min !== null) {
        min = typeof min === 'number' ? min : intervalToMs(min, range);
        if (res < min) {
          throw new _loggingAndErrors.HpError(`The 'interval' cannot be less than ${min}ms. Instead got '${interval}'`);
        }
      }
      if (max !== null) {
        max = typeof max === 'number' ? max : intervalToMs(max, range);
        if (res > max) {
          throw new _loggingAndErrors.HpError(`The 'interval' cannot be greater than ${max}ms. Instead got '${interval}'`);
        }
      }
      return res;
    }
  }
  throw new _loggingAndErrors.HpError(`The 'interval' must be a number and optional suffix: [d]ay, [h]our, [m]inute, [s]econds. Instead got '${interval}'.`);
}